import type { ModelChain } from '@app/api/Chains';
import type { NChains } from '@app/types/Chains';

export const adaptChainsToRedux = (data: ModelChain): NChains.Chain | null => {
  let result: NChains.Chain | null = null;
  const { ChainBranches, CountBranches, Id, IsDeleted, Name } = data;

  result = {
    chainBranches: ChainBranches,
    countBranches: CountBranches,
    id: Id,
    isDeleted: IsDeleted,
    name: Name || '',
  };

  return result;
};
